import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

const AuthRoute = ({ children }: { children: ReactElement }) => {
  const location = useLocation();

  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const { userType } = useAppSelector((s) => s.auth);
  const isManagement = userType?.toLowerCase().includes("management");
  const isAdmin = userType?.toLowerCase().includes("admin");


  if (isAuthenticated) {
    if (isManagement && location.pathname === '/management_login') {
      return <Navigate to="/management-dashboard" replace />;
    }
    if (isAdmin){
      return <Navigate to="/admin-dashboard" replace />;
    }
    if (['/', '/verification'].includes(location.pathname)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default AuthRoute;
